import { Outlet } from 'react-router-dom';

// Banking destinations live in the grouped Accounting navigation.
export const BankingLayout = () => <Outlet />;
